import classnames from 'classnames';
import React from 'react';

import styles from './Link.css';

type LinkParams = {
    href: string;
    target?: string;
    rel?: string;
    children?: React.ReactNode;
    className?: string;
    noWrap?: boolean;
    onClick?: React.EventHandler<React.SyntheticEvent<HTMLAnchorElement>>;
    dataTest?: string;
};
export function Link({
    href,
    target,
    rel,
    noWrap,
    children,
    className = '',
    onClick,
    dataTest,
}: LinkParams) {
    if (href && href.startsWith('http')) {
        target = '_blank';
        rel = 'noopener noreferrer';
    }
    return (
        <a
            className={classnames({ [styles.noWrap]: noWrap }, className)}
            href={href}
            target={target}
            rel={rel}
            onClick={onClick}
            data-test={dataTest}
        >
            {children}
        </a>
    );
}
